<template>
  <div
    :class="{
      'is-mobile': isMobile
    }"
  >
    <template v-if="isMobile">
      <div class="mobile-head">
        <span
          v-for="(item, index) in classify"
          :key="index"
          :class="{
            'cur': listParams.cftId === item.cftId
          }"
          @click="switchCftid(item.cftId)"
        >{{ item.name }}</span>
      </div>
      <div class="mobile-head-search">
        <div style="flex: 1">
          <el-input placeholder="请输入看板名称/看板指标关键字" v-model="listParams.name" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="goList(1)"></el-button>
          </el-input>
        </div>
        <div style="padding-left: 10px">
          <el-checkbox
            v-model="listParams.isCollect"
            :true-label="1"
            :false-label="0"
            @change="goList(1)"
          >
            收藏
          </el-checkbox>
        </div>
      </div>
      <div class="mobile-body cf">
        <div
          class="mobile-retrieval-box"
          :class="{
            'margin-right-0': (index + 1) % 2 === 0
          }"
          v-for="(item, index) in retrievalList"
          :key="index"
        >
          <div class="box-head">
            <div class="name">{{ item.name }}</div>
            <div
              class="collect"
              :class="{
                'yes-collect': item.isCollect
              }"
              @click.prevent.stop="collect(item)"
            >
              <i class="el-icon-star-on"></i>收藏
            </div>
          </div>
          <div class="box-body" @click="toUrl(item.url)"><img width="100%" :src="item.picUrl" /></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="retrieval-head">
        <div class="site-name">可视化数据看板</div>
        <el-select v-model="listParams.cftId" placeholder="请选择" size="small">
          <el-option
            v-for="item in classify"
            :key="item.cftId"
            :label="item.name"
            :value="item.cftId"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="listParams.name"
          placeholder="请输入看板名称/看板指标关键字"
          size="small"
          style="width: 230px;margin: 0 .5rem"
        ></el-input>
        <div>
          <el-button
            type="primary"
            size="small"
            style="width: 80px"
            @click="goList(1)"
          >
            搜索
          </el-button>
        </div>
        <div style="padding: .2rem 0 .2rem 1rem">
          <el-checkbox
            v-model="listParams.isCollect"
            :true-label="1"
            :false-label="0"
            @change="goList(1)"
          >
            只看我收藏的
          </el-checkbox>
        </div>
        <div class="users">
          <span>{{ userName }}</span>
          <span class="sign-out" @click="signOut">退出</span>
        </div>
      </div>
      <div class="retrieval-body cf" v-if="!isEmpty">
        <div
          class="retrieval-box"
          :class="{
            'margin-right-0': (index + 1) % 5 === 0
          }"
          v-for="(item, index) in retrievalList"
          :key="index"
        >
          <div class="box-head">
            <div class="name">{{ item.name }}</div>
            <div
              class="collect"
              :class="{
                'yes-collect': item.isCollect
              }"
              @click.prevent.stop="collect(item)"
            >
              <i class="el-icon-star-on"></i>收藏
            </div>
          </div>
          <div class="box-body" @click="toUrl(item.url, 'open')"><img width="100%" :src="item.picUrl" /></div>
        </div>
      </div>
    </template>
    <div class="error-box" v-if="isEmpty">
      <div class="icon"><span class="el-icon-close"></span></div>
      <div class="text">当前无数据</div>
    </div>
    <div v-if="retrievalTotal">
      <el-pagination
        layout="prev, pager, next"
        :total="retrievalTotal"
        background
        :page-size="listParams.pageSize"
        :current-page="listParams.pageNum"
        class="retrieval-pages"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      isMobile: false,
      isEmpty: false,
      classify: [{
        cftId: '',
        name: '全部看板分类'
      }],
      retrievalList: [],
      retrievalTotal: 0,
      listParams: {
        pageSize: 20,
        pageNum: 1,
        name: '',
        cftId: '',
        isCollect: ''
      },
      userName: ''
    }
  },
  methods: {
    // 对象转URL参数
    urlEncode (param, key, encode) {
      if (param == null) return ''
      var paramStr = ''
      var t = typeof (param)
      if (t === 'string' || t === 'number' || t === 'boolean') {
        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param)
      } else {
        for (var i in param) {
          var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
          paramStr += this.urlEncode(param[i], k, encode)
        }
      }
      return paramStr
    },
    // 收藏
    collect (data) {
      this.$service.fetch({
        method: 'POST',
        url: 'api/search/collect',
        data: {
          searchId: data.searchId
        }
      }).then(() => {
        this.$set(data, 'isCollect', data.isCollect === 1 ? 0 : 1)
      })
    },
    toUrl (url, type) {
      if (type === 'open') {
        window.open(url, '_blank')
      } else {
        window.location = url
      }
    },
    // 退出
    signOut () {
      const routeQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.$delete(routeQuery, 'token')
      const paramStr = this.urlEncode(routeQuery).substr(1)
      localStorage.removeItem('token')
      this.$router.push({
        name: 'login',
        query: {
          redirect: `${this.$route.path}?${paramStr ? `?${paramStr}` : ''}`
        }
      })
    },
    changePage (e) {
      this.listParams.pageNum = e
      this.goList(0)
    },
    goList (type) {
      if (type) {
        this.listParams.pageNum = 1
      }
      this.isEmpty = false
      this.$service.fetch({
        method: 'GET',
        url: 'api/search/list',
        params: this.listParams
      }).then(res => {
        if (this.listParams.pageNum === 1 && !res.data.length) {
          this.isEmpty = true
        }
        this.retrievalList = res.data
        this.retrievalTotal = res.total
        this.userName = res.userName
      })
    },

    // 以下是手机端相关
    switchCftid (id) {
      if (id !== this.listParams.cftId) {
        this.listParams.cftId = id
        this.listParams.pageNum = 1
        this.goList(0)
      }
    }
  },
  created () {
    const sUserAgent = navigator.userAgent.toLowerCase()
    const isMobile = !!sUserAgent.match(/mobile/)
    if (isMobile) {
      this.listParams.pageSize = 10
    }
    this.isMobile = isMobile
    this.goList()
    this.$service.fetch({
      method: 'GET',
      url: 'api/search/cft/list'
    }).then(res => {
      this.classify = this.classify.concat(res.data)
    })
  }
}
</script>

<style lang="stylus" scoped>
// PC
.retrieval-head
  background  #1a1939
  display flex
  padding .8rem 1rem
  .site-name
    color #fff
    font-size 1rem
    line-height 32px
    padding-right 1rem
  .users
    flex 1
    text-align right
    color #fff
    font-size .8rem
    line-height 32px
    span
      margin-left 1rem
    .sign-out
      cursor pointer
.retrieval-body
  padding 1rem
  padding-bottom 0
  .retrieval-box
    background  #1a1939
    width calc(20% - .48rem)
    border-radius .5rem
    overflow hidden
    float left
    margin 0 .6rem .6rem 0
    .box-head
      height 2rem
      line-height 2rem
      display flex
      background #1f1e44
      color #fff
      padding 0 .5rem
      font-size .8rem
      .name
        flex 1
      .collect
        text-align right
        cursor pointer
        font-size .6rem
      .yes-collect
        color #007eff
    .box-body
      padding .5rem
      cursor pointer
      img
        border-radius .3rem
.retrieval-pages
  background none
  border 0 none
  padding 0 1rem 1rem 1rem
  text-align right
  >>>.btn-next
    margin-right 0
.is-mobile .retrieval-pages
  text-align center
.margin-right-0
  margin-right 0 !important
.error-box
  width 100%
  color #fff
  position fixed
  left 0
  text-align center
  top 50%
  transform translateY(-50%)
  .icon
    width 100px
    height 100px
    line-height 100px
    font-size 70px
    margin 0 auto
    opacity .3
    border-radius 100%
    color #000
    background #fff
  .text
    height 50px
    line-height 50px
    padding-top 10px
    opacity .4
    font-size 25px
// 手机
.mobile-head
  height 40px
  line-height 40px
  background  #1a1939
  overflow-y auto
  white-space nowrap
  color rgba(255, 255, 255, .8)
  font-size 12px
  margin-bottom 5px
  span
    padding 0 10px
  .cur
    color #007eff
.mobile-head-search
  background  #1a1939
  padding 10px 5px
  display flex
.mobile-body
  padding 10px
  .mobile-retrieval-box
    width calc(50% - 5px)
    float left
    margin 0 10px 10px 0
    background  #1c1839
    border-radius 10px
    overflow hidden
    .box-head
      height 30px
      line-height 30px
      display flex
      background #1f1e44
      color #fff
      padding 0 10px
      font-size 14px
      .name
        flex 1
      .collect
        text-align right
        cursor pointer
        font-size 12px
      .yes-collect
        color #007eff
    .box-body
      padding 10px
      cursor pointer
      img
        border-radius 6px
  .margin-right-0
    margin-right 0
.is-mobile
  .error-box
    .icon
      width 50px
      height 50px
      line-height 50px
      font-size 30px
    .text
      height 30px
      line-height 30px
      padding-top 5px
      font-size 15px
</style>
